<div [chart]="stockChart"></div>
